/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionnightnote2Inputs */

const en_actionnightnote2 = /** @type {(inputs: Actionnightnote2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pushes only go out from 8 am.`)
};

const de_actionnightnote2 = /** @type {(inputs: Actionnightnote2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitteilungen gehen erst um 8 Uhr raus.`)
};

/**
* | output |
* | --- |
* | "Pushes only go out from 8 am." |
*
* @param {Actionnightnote2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionnightnote2 = /** @type {((inputs?: Actionnightnote2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionnightnote2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionnightnote2(inputs)
	return de_actionnightnote2(inputs)
});
export { actionnightnote2 as "actionNightNote" }